var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBG"},[_c('v-row',{staticClass:"containerLogin"},[_c('div',{staticClass:"itemLogin"},[_c('form-login-component')],1),_c('div',{staticClass:"itemCarousel"},[_c('carousel-component')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }